export const ContentEncoding = {
    none: '',
    gzip: '.gz',
    brotli: '.br'
};
